module.exports = __webpack_public_path__ + "static/img/13.3d6c519.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/1/zh/13.png
// module id = 3v+/
// module chunks = 0